import React, { useRef, useCallback } from 'react';
import Card from './Card/Card';
import './NewCollections/AllNewCollections.css';

const ProductGrid = ({
  title = "Products",
  products,
  isLoading,
  error,
  hasMore,
  fetchMore,
  endMessage = " "
}) => {
  const observer = useRef();

  const lastProductRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchMore();
        }
      });

      if (node) observer.current.observe(node);
    },
    [isLoading, fetchMore, hasMore]
  );

  if (error) {
    return (
      <div className="error-container container">
        <p>Error: {error.message || 'Network Error'}</p>
      </div>
    );
  }

  return (
    <div className="container">
      <h2 className="text-center" style={{color:"var(--textHeading"}}>{title}</h2>
      <div className="product-grid">
        {products?.map((product, index) => (
          <div
            className="product-grid-card"
            key={product.id}
            ref={index === products.length - 1 ? lastProductRef : null}
          >
            <Card item={product} />
          </div>
        ))}
      </div>

      {isLoading && (
        <div className="loading-container container">
          <div className="product-grid">
            {Array.from({ length: 6 }).map((_, index) => (
              <div className="product-grid-card" key={index}>
                <div className="skeleton-card card h-100">
                  <div className="skeleton-image"></div>
                  <div className="skeleton-text"></div>
                  <div className="skeleton-text short"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {!hasMore && !isLoading && (
        <p className="text-center fw-bold fs-4 mt-4">{endMessage}</p>
      )}
    </div>
  );
};

export default ProductGrid;